import { matchPath } from 'react-router-dom';
const basePath = (window as any).CSG_CONFIG.BASE_PATH;
export const LoginRoute = '';
export const ForgotPasswordRoute = 'forgot-password';
export const MessageCenterRoute = 'message-center';
export const MessageDetailsRoute = 'message-details';
export const ReportingRoute = 'reporting';
export const ForgotPasswordConfirmationRoute = 'forgot-password-confirmation';
export const TrashBinRoute = 'trash-bin';
export const HelpDeskRoute = 'help-desk';
export const LoadingRoute = 'loading';
export const HeartbeatRoute = 'heartbeat';
export const UserAccountRoute = 'user-account';
export const TemplateMaintenanceRoute = 'selectivity-template-maintenance';
export const LandingRoute = '';
export const authRoutes = [
  `/${basePath}/` + MessageCenterRoute,
  `/${basePath}/` + MessageDetailsRoute,
  `/${basePath}/` + TrashBinRoute,
  `/${basePath}/` + UserAccountRoute,
  `/${basePath}/` + ReportingRoute,
  `/${basePath}/` + LandingRoute,
  `/${basePath}/` + TemplateMaintenanceRoute,
];
export const isAuthRoute = (pathname: string): boolean => {
  return (
    authRoutes.includes(pathname) ||
    matchPath(`/bc/message-details/:messageId/:sysPrin/:docTypeId`, location.pathname) !== null
  );
};
